export default __webpack_public_path__ + "static/media/me2.bdec4215.jpg";